import { accountSearchColumns, chiPhiSearchColumns, khachHangSearchColumns, QUERY_KEYS } from '@/constants';
import type { DataTableColumn, DataTableRenderCellParams } from '@/components/custom/erp/data-table-v2';
import { CellFieldV2 as CellField, SearchFieldV2 as SearchField } from '@/components/custom/erp';
import { AccountModel, ChiPhi, DoiTuong } from '@/types/schemas';
import { FormMode } from '@/types/form';

export const getTableColumns = (
  onCellValueChange: (rowUuid: string, field: string, newValue: MuaHangRecord) => void,
  formMode: FormMode
) => [
  {
    field: 'ma_cp',
    headerName: 'Mã chi phí',
    width: 180,
    renderCell: (params: DataTableRenderCellParams) => (
      <SearchField<ChiPhi>
        type='text'
        searchEndpoint={`/${QUERY_KEYS.CHI_PHI}/`}
        searchColumns={chiPhiSearchColumns}
        columnDisplay='ma_cp'
        dialogTitle='Danh mục chi phí'
        value={params.row.ma_cp_data?.ma_cp || ''}
        onRowSelection={(row: MuaHangRecord) => onCellValueChange(params.row.uuid, 'ma_cp_data', row)}
        disabled={formMode === 'view'}
      />
    ),
    pasteConfig: {
      lookupKey: 'ma_cp',
      resultField: 'ma_cp_data',
      detailEndpoint: QUERY_KEYS.CHI_PHI
    }
  },
  {
    field: 'ten_cp',
    headerName: 'Tên chi phí',
    width: 200,
    renderCell: (params: DataTableRenderCellParams) => (
      <CellField
        name='ten_cp'
        type='text'
        value={params.row.ma_cp_data?.ten_cp || ''}
        onValueChange={newValue => onCellValueChange(params.row.uuid, 'ten_cp', newValue)}
        disabled={formMode === 'view'}
      />
    ),
    nonWritable: true
  },
  {
    field: 'tien_cp_nt',
    headerName: 'Tiền VND',
    width: 150,
    renderCell: (params: DataTableRenderCellParams) => (
      <CellField
        name='tien_cp_nt'
        type='number'
        value={params.row.tien_cp_nt}
        onValueChange={newValue => onCellValueChange(params.row.uuid, 'tien_cp_nt', newValue)}
        disabled={formMode === 'view'}
      />
    )
  },
  {
    field: 'loai_pb',
    headerName: 'Tiêu thức phân bổ',
    width: 150,
    renderCell: (params: DataTableRenderCellParams) => {
      switch (params.row.ma_cp_data?.loai_pb) {
        case '1':
          return '1. Số lượng';
        case '2':
          return '2. Thể tích';
        case '3':
          return '3. Khối lượng';
        case '4':
          return '4. Giá trị';
        default:
          break;
      }
    }
  },
  {
    field: 'ma_kh',
    headerName: 'Mã NCC',
    width: 180,
    renderCell: (params: DataTableRenderCellParams) => (
      <SearchField<DoiTuong>
        type='text'
        searchEndpoint={`/${QUERY_KEYS.NHA_CUNG_CAP}/`}
        searchColumns={khachHangSearchColumns}
        columnDisplay='customer_code'
        dialogTitle='Danh mục đối tượng'
        value={params.row.ma_kh_data?.ma_kh || ''}
        onRowSelection={(row: MuaHangRecord) => {
          onCellValueChange(params.row.uuid, 'ma_kh_data', row);
        }}
        disabled={formMode === 'view'}
      />
    ),
    pasteConfig: {
      lookupKey: 'ma_kh',
      resultField: 'ma_kh_data',
      detailEndpoint: QUERY_KEYS.NHA_CUNG_CAP
    }
  },
  {
    field: 'ten_kh',
    headerName: 'Tên nhà cung cấp',
    width: 200,
    renderCell: (params: DataTableRenderCellParams) => (
      <CellField
        name='ten_kh'
        type='text'
        value={params.row.ma_kh_data?.customer_name || params.row.ma_kh_data?.ten_kh || ''}
        onValueChange={newValue => onCellValueChange(params.row.uuid, 'ten_kh', newValue)}
        disabled={formMode === 'view'}
      />
    ),
    nonWritable: true
  },
  {
    field: 'tk',
    headerName: 'Tk có',
    width: 150,
    renderCell: (params: DataTableRenderCellParams) => (
      <SearchField<AccountModel>
        type='text'
        searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
        searchColumns={accountSearchColumns}
        columnDisplay='code'
        dialogTitle='Danh mục tài khoản'
        value={params.row.tk_data?.code || ''}
        onRowSelection={(row: MuaHangRecord) => onCellValueChange(params.row.uuid, 'tk_data', row)}
        disabled={formMode === 'view'}
      />
    ),
    pasteConfig: {
      lookupKey: 'code',
      resultField: 'tk_data',
      detailEndpoint: QUERY_KEYS.TAI_KHOAN
    }
  }
];
